import { type ReactNode } from "react";
import { useAuth } from "../providers/AuthContext";
import RouteFallback from "../ui/RouteFallback";
import Login from "../../Routes/Login";

const AuthGate = ({ children }: { children?: ReactNode }): JSX.Element | null => {
    const { isAuthenticated } = useAuth();

    return isAuthenticated === undefined ? (
        <RouteFallback />
    ) : isAuthenticated ? (
        <>{children}</>
    ) : (
        <Login />
    );
};

export default AuthGate;
